import React, { useEffect, useState, Suspense, lazy } from "react";
import {
  OverlayTrigger,
  Tooltip,
  Accordion,
  Card,
  Dropdown,
} from "react-bootstrap";
import SVG from "react-inlinesvg";
import { Link, Switch, Redirect } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useLang } from "../../../../_themeBase/i18n";
import {
  LayoutSplashScreen,
  ContentRoute,
} from "../../../../_themeBase/layout";
import "../../../../_themeBase/_assets/sass/pages/login/classic/login-1.scss";
import { LanguageSelectorDropdown } from "../../../../_themeBase/layout/components/extras/dropdowns/LanguageSelectorDropdown";
import * as actions from "../../../../app/actions/generalActions";
import { toAbsoluteUrl } from "../../../../_themeBase/_helpers";
import { convertDateStringToLocal } from "../../../../_themeBase/_helpers/DateFormaterHelpers";
import { getInitialInfo } from "../_redux/authCrud";


const Login = lazy(() => import("./Login"));
const Registration = lazy(() => import("./Registration"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const ChangePassword = lazy(() => import("./ChangePassword"));
const AddMeFormPage = lazy(() => import("./saveMeForm/AddMeFormPage"));
const AddMeUploadFilesInformation = lazy(() => import("./saveMeForm/AddMeUploadFilesInformation"));

const languages = ["Farsi", "English"];
export const appVersion = process.env.REACT_APP_APP_VERSION;
export const publishDate = process.env.REACT_APP_PUBLISH_DATE;
export const AuthPage = () => {
  // const optCheck = true
  const [activeLanguages, setActiveLanguages] = useState(languages);

  const dispatch = useDispatch();
  useEffect(() => {
    var query = {
      whereClause: "",
      whereClauseParameters: [],
      orderClause: "id asc ",
      skipCount: 0,
      takeCount: 5,
    };

    getInitialInfo()
      .then((response) => {
        setActiveLanguages(response.data.data.languages);
        dispatch(actions.fetchObjects("api/Blog", "blogs", query, "GetNews"));
      })
      .catch((error) => {
        setActiveLanguages(languages);
        if (error.response) {
          //setStatus(error.response.data.Message);
        } else {
          // setStatus(
          //   intl.formatMessage({
          //     id: "AUTH.VALIDATION.INVALID_LOGIN",
          //   })
          // );
        }
      });
  }, []);

  const { blogList } = useSelector(
    (state) => ({ blogList: state.baseInfo.blogs }),
    shallowEqual
  );
  const locale = useLang();

  return (
    <>
      {/* <SetLayout /> */}
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-dark"
          id="kt_login"
        >
          {/*begin::Content*/}
          <div
            className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden "
            style={{
              backgroundImage: `url(${toAbsoluteUrl(
                "/images/Style/Background.jpg"
              )})`,
            }}
          >
            {/* <div className="float-right"> */}
            <Link to="/" className="flex-column-auto mt-2 float-left">
              <img
                alt="Logo"
                className="max-h-45px rounded float-left"
                src={toAbsoluteUrl("/images/Logo/CullinanLogo.png")}
              />
            </Link>
            {/* </div> */}
            {/*begin::Content header*/}
            <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              <LanguageSelectorDropdown activeLanguages={activeLanguages} />
            </div>
            <div className="position-absolute bottom-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              {/* <span className="font-weight-bold text-dark-50">Don't have an account yet?</span> */}
              {/* <Link to="/auth/registration" className="font-weight-bold ml-2" id="kt_login_signup">Sign Up!</Link> */}
              Powered by{" "}
              <a
                target="_blank"
                href="http://padide-af.com/"
                title="Padide Asr Fannavari"
              >
                {/* <span id="Label1" style="color:white"> */}
                7Diamonds
                {/* </span> */}
              </a>
              <br />
              <span id="Label1">Last Update: {publishDate}</span>
              <br />
              <span id="lblVersion">Version : {appVersion} </span>
            </div>
            {/*end::Content header*/}

            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                  <ContentRoute path="/auth/login" component={Login} />
                  <ContentRoute
                    path="/auth/registration"
                    component={Registration}
                  />
                  <ContentRoute
                    path="/auth/change-password"
                    component={ChangePassword}
                  />
                  <ContentRoute
                    path="/auth/forgot-password"
                    component={ForgotPassword}
                  />
                  <ContentRoute
                    path="/auth/pre-register"
                    component={AddMeFormPage}
                  />
                  {/* <ContentRoute
                    path="/auth/pre-register"
                    render={(props) => (
                      <AddMeFormPage
                        {...props}
                        // isFullAccess={isFullAccess}
                        basePath="/auth"
                        api="api/user"
                      // fieldList={importFieldList}
                      // initObject={initObject}
                      // functionName="ImportUsersFromCsvFile"
                      // baseStateName={currentState.name}
                      />
                    )}
                  /> */}

                  <Redirect from="/auth" exact={true} to="/auth/login" />
                  <Redirect to="/auth/login" />
                </Switch>
              </Suspense>
            </div>
            {/* <CardSlider data={cards} /> */}
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2"></div>
              <div className="d-flex order-1 order-sm-2 my-2"></div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}

          {/*begin::Aside*/}
          <div className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10">
            {/*begin: Aside Container*/}

            <div className="d-flex flex-row-fluid flex-column justify-content-between rounded float-left">
              {/* start:: Aside header */}
              <div className="rounded float-left">
                <div className="row float-right">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="language-panel-tooltip">
                        <FormattedMessage id="AUTH.APPLICATION" />
                      </Tooltip>
                    }
                  >
                    <div className="btn btn-icon btn-clean btn-rounded">
                      <span className="svg-icon svg-icon-primary svg-icon-lg rounded-circle">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/devices/Android.svg"
                          )}
                        />
                      </span>
                    </div>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="language-panel-tooltip">
                        <FormattedMessage id="AUTH.HELP" />
                      </Tooltip>
                    }
                  >
                    <div className="btn btn-icon btn-clean btn-rounded">
                      <span className="svg-icon svg-icon-primary svg-icon-lg rounded-circle">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/media/dvd.svg")}
                        />
                      </span>
                    </div>
                  </OverlayTrigger>
                </div>

                {/* <Card className="row  bg-transparent border-0">
                  <Card.Header className="bg-transparent text-primary no-border"> <FormattedMessage id="LOGIN.NEWS" /></Card.Header>
                  <Card.Body>
                    {blogList.entities && <Accordion defaultActiveKey="0" >
                      {blogList.entities.map((item, index) =>
                        <Card className="bg-transparent border-0 mb-5">
                          <Card.Header className="bg-transparent ">
                            <Accordion.Toggle className="bg-transparent border-0" variant="link" eventKey={+index}>
                              <div className="d-flex ">
                                <span className="svg-icon svg-icon-warning mr-5 svg-icon-lg">
                                  <SVG
                                    src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")}
                                  ></SVG>
                                </span>
                                <div>
                                  <a
                                    href="#"
                                    className="font-size-h6 text-dark-25 text-hover-primary font-weight-bolder"
                                  >
                                    {item.title}      -     {convertDateStringToLocal(item.date, locale)}
                                  </a>
                                </div>
                              </div>
                            </Accordion.Toggle>
                          </Card.Header>
                          <Accordion.Collapse eventKey={+index}>
                            <Card.Body>{ReactHtmlParser(item.body)}</Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      )}
                    </Accordion>}
                  </Card.Body>
                </Card> */}

                <div className={`card card-custom bg-transparent border-0`}>
                  {/* Header */}
                  <div className="card-header border-0">
                    <h3 className="card-title font-weight-bolder text-primary">
                      {" "}
                      <FormattedMessage id="LOGIN.NEWS" />{" "}
                    </h3>
                  </div>

                  {/* Body */}
                  <div className="card-body scrollBlog pt-0 border-0">
                    {blogList.entities && (
                      <Accordion defaultActiveKey="0">
                        {blogList.entities.map((item, index) => (
                          <Card className="bg-transparent border-0 mb-5" key={item.id}>
                            <Card.Header className="bg-transparent ">
                              <Accordion.Toggle
                                className="bg-transparent border-0"
                                variant="link"
                                eventKey={+index}
                              >
                                <div className="d-flex ">
                                  <span className="svg-icon svg-icon-warning mr-5 svg-icon-lg">
                                    <SVG
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/Home/Library.svg"
                                      )}
                                    ></SVG>
                                  </span>
                                  <div>
                                    <a
                                      href="#"
                                      className="font-size-h7 text-dark-25 text-hover-primary font-weight-bolder"
                                    >
                                      {convertDateStringToLocal(
                                        item.date,
                                        locale
                                      )}{" "}
                                      - {item.title}
                                    </a>
                                  </div>
                                </div>
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey={+index}>
                              <Card.Body>
                                {ReactHtmlParser(item.body)}
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        ))}
                      </Accordion>
                    )}
                  </div>
                </div>

                {/* <div className={`card card-custom bg-transparent border-0`}>
                  <div className="card-header border-0">
                    <h3 className="card-title font-weight-bolder text-primary"> <FormattedMessage id="LOGIN.NEWS" /> </h3>
                  </div>

                  <div className="card-body scrollBlog pt-0">

                    {blogList.entities && <Accordion defaultActiveKey="0" >
                      {blogList.entities.map((item, index) =>

                        <Card className="bg-transparent border-0 mb-5">
                          <div className="d-flex align-items-center mb-1 bg-light-warning rounded p-2">

                            <Card.Header className="bg-transparent ">
                              <Accordion.Toggle className="bg-transparent border-0" variant="link" eventKey={+index}>

                                <div className="d-flex  flex-grow-1 mr-2">
                                  <span className="svg-icon svg-icon-warning mr-5 svg-icon-lg">
                                    <SVG
                                      src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")}
                                    ></SVG>
                                  </span>
                                  <a
                                    href="#"
                                    className="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                  >
                                    {item.title}
                                  </a>
                                </div>
                                <span className="text-muted font-weight-bold ml-10">{convertDateStringToLocal(item.date, locale)}</span>

                              </Accordion.Toggle>

                            </Card.Header>

                            <Accordion.Collapse eventKey={+index}>
                              <Card.Body>{ReactHtmlParser(item.body)}</Card.Body>
                            </Accordion.Collapse>
                          </div>
                        </Card>

                      )}
                    </Accordion>}
                  </div>

                </div> */}

                {/* 
                <Card className="row mt-10 bg-transparent border-0">
                  <Card.Header className="bg-transparent text-primary no-border"> <FormattedMessage id="LOGIN.NEWS" /></Card.Header>
                  <Card.Body>
                    {blogList.entities && <Accordion defaultActiveKey="0" >
                      {blogList.entities.map((item, index) =>
                        <Card className="bg-transparent border-0 d-flex align-items-center justify-content-between mb-5">
                          <Card.Header className="bg-transparent ">
                            <Accordion.Toggle variant="link" eventKey={+index}>
                              {item.title}
                            </Accordion.Toggle>
                          </Card.Header>
                          <Accordion.Collapse eventKey={+index}>
                            <Card.Body>{ReactHtmlParser(item.body)}</Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      )}
                    </Accordion>}
                  </Card.Body>
                </Card> */}
              </div>
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                {/* <CardSlider data={cards} /> */}
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  &copy; <FormattedMessage id="COPY.WRITE.BEFORE" />{" "}
                  {/* <Link
                    to="http://padide-af.com/"
                    target="_blank"
                    className="text-primary"
                  > */}
                  <a
                    target="_blank"
                    href="http://padide-af.com/"
                    title="عصر پدیده فناوری"
                  >
                    <FormattedMessage id="COMPANY.NAME" />
                  </a>
                  {/* </Link>{" "} */}
                  <FormattedMessage id="COPY.WRITE.AFTER" />
                </div>
              </div>

              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
};

const cards = [
  {
    image: "/images/cardSlides/etebari.jpg",
    title: "خدمات اعتباری",
    subtitle: "Advertising",
  },
  {
    image: "/images/cardSlides/kar_daneshjooi.jpg",
    title: "کار دانشجویی",
    subtitle: "Sound & Vision",
  },
  {
    image: "/images/cardSlides/taradod.jpg",
    title: "حضور و غیاب پرسنل",
    subtitle: "Accounting",
  },
  {
    image: "/images/cardSlides/etebari.jpg",
    title: "خدمات اعتباری",
    subtitle: "Advertising",
  },
  {
    image: "/images/cardSlides/kar_daneshjooi.jpg",
    title: "کار دانشجویی",
    subtitle: "Sound & Vision",
  },
  {
    image: "/images/cardSlides/taradod.jpg",
    title: "حضور و غیاب پرسنل",
    subtitle: "Accounting",
  },
];
